import axios from "axios";
export default {
  data() {
    return {
      newImage: "",
      file: '',
      uploadPercentage: 0,
      filesTotal : 0,
      currentfile : 0,
      fileProgressShow: false,
      res: [],
      fileError: []
    };
  },
  methods: { 
    uploadImages(files) {
      this.fileError = [];
      var vm = this;
      return new Promise(resolve => {
        vm.filesTotal = 0;
        vm.currentfile = 0;
        vm.res = [];
        vm.uploadPercentage =0
        //Percorre o array de imagens e adiciona os itens na requisicao
        vm.filesTotal = files.length;
        this.uploadAxios(files,resolve)
      });
    },

    async uploadAxios(files,resolve){
      let token = this.$session.get("jwt");
      let siteId = this.$session.get("siteId");
      var load = 0;
      var all = 0;
      var x = 0;
      var vm = this;
      for (const [key, value] of Object.entries(files)) {
        var formData = new FormData(); // Create new FormData
        formData.append("images[]", files[key]);
        try {
          const request = await axios({
          method: "post",
          url: `${process.env.ROOT_API}api/site/${siteId}/upload/images`,
          data: formData,
          headers: {
            Authorization: "Bearer " + token
            // 'Content-Type': 'application/x-www-form-urlencoded'
          },
          onUploadProgress: function(progressEvent) {
            load = progressEvent.loaded;
            all = progressEvent.total;
            var porcentege = (load / all );
            vm.uploadPercentage = (((vm.currentfile + porcentege) * 100 )/ vm.filesTotal);
            if ( load == all){
              vm.currentfile = x + 1;
            }
            // console.log("Loaded1 :",load,"kb", "Total1:" , all,"kb", "Porcentagem1: ", porcentege, "%");
            // console.log("Loaded1 :",vm.currentfile, "Total1:" , vm.filesTotal, "Porcentagem1: ", vm.uploadPercentage, "%");
          }
        },
        ) 
          .then(response => {
            x = x + 1;
            if (response.data.status == 1) {
              if(response.data.file_source[0] == undefined){
                vm.fileError.push(files[x-1].name);
                // console.log(vm.fileError);
                if(x == vm.filesTotal){
                  var parsedobj = JSON.parse(JSON.stringify(vm.res));
                  resolve(parsedobj);
                  vm.fileProgressShow = false;
                }
              } 
              else{
                vm.res.push(response.data.file_source[0]);
                if(x == vm.filesTotal){
                  var parsedobj = JSON.parse(JSON.stringify(vm.res));
                  resolve(parsedobj);
                  vm.fileProgressShow = false;
                }
              } 
            } 
            else {
              resolve("Erro upload");
            }
          })
          .catch(response => {
            x = x + 1;
            vm.fileError.push(files[x-1].name);
            if(x == vm.filesTotal){
              var parsedobj = JSON.parse(JSON.stringify(vm.res));
              resolve(parsedobj);
              vm.fileProgressShow = false;
            }
            console.log(response);
        });
      } catch (e) {
        this.errors.push(e)
      }
      }
    },

    // uploadImages(files) {
    //   var vm = this
    //   return new Promise(resolve => {
    //     let formData = new FormData();
    //     let token = this.$session.get("jwt");
    //     let siteId = this.$session.get("siteId");
    //     //Percorre o array de imagens e adiciona os itens na requis sicao
    //     for (var i = 0; i < files.length; i++) {
    //       formData.append("images[]", files[i]);
    //     }
    //     axios({
    //       method: "post",
    //       url: `${process.env.ROOT_API}api/site/${siteId}/upload/images`,
    //       data: formData,
    //       headers: {
    //         Authorization: "Bearer " + token
    //         // 'Content-Type': 'application/x-www-form-urlencoded'
    //       },
    //       onUploadProgress: function(progressEvent) {
    //         vm.uploadPercentage = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
    //         // console.log("Loaded :",progressEvent.loaded, "Total:" , progressEvent.total, "Porcentagem: ", vm.uploadPercentage, "%");
    //      } 
    //     },
    //     )
    //       .then(response => {
    //         if (response.data.status == 1) {
    //           resolve(response.data.file_source); 
    //         } else {
    //           resolve("Erro upload");
    //         }
    //       })
    //       .catch(response => {
    //         console.log("Falha ao subir imagem");
    //         console.log(response);
    //       });
    //   });
    // },
    uploadImage(file) {
      return new Promise(resolve => {
        this.loading = true;
        let formData = new FormData();
        let token = this.$session.get("jwt");
        formData.append("images[]", file[0]);
        let siteId = this.$session.get("siteId");
        axios({
          method: "post",
          url: `${process.env.ROOT_API}api/site/${siteId}/image/upload`,
          data: formData,
          headers: {
            Authorization: "Bearer " + token
            // 'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
          .then(response => {
            if (response.data.status == 1) {
              resolve(response.data.file_source[0]);
            } else {
              resolve("Erro upload");
            }
          })
          .catch(response => {
            console.log("Falha ao subir imagem");
          });
        this.loading = false;
      });
    },
    clearImage() {
      this.newImage = "";
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/uploadFiles.js